import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

const FormHeader = ({ title, toggle }) => {
  return (
    <h3>
      {title}
      <FontAwesomeIcon
        icon={faCircleXmark}
        className="close-icon"
        onClick={() => toggle()}
      />
    </h3>
  );
};

export default FormHeader;
